import { get, post } from "@/utils/https";

// 获取银行卡信息
export function getHmBankConfigs() {
  return get(`/api/v1/common/saas/app/offline/apply/getHmBankConfigs`);
}

//  获取线下还款卡号
export function getApplyRepayCard(bizNo) {
  return get(
    `/api/v1/common/saas/app/offline/apply/getApplyRepayCard/${bizNo}`
  );
}

//  用户协议签署
// export function applyHmSign(data) {
//   return post(`/api/v1/common/saas/app/offline/apply/hm/sign`, data);
// }

//  合墨数据-短信发送
export function sendSms(data) {
  return post(`/api/v1/common/saas/app/offline/apply/hm/sendSms`, data);
}

//  合墨数据-短信绑卡确认
export function signVerify(data) {
  return post(`/api/v1/common/saas/app/offline/apply/hm/signVerify`,data);
}

//  合墨数据-更换银行卡
// export function applyHmSignChange({ bizNo, ...data }) {
//   return post(
//     `/api/v1/common/saas/app/offline/apply/change/bank/card/${bizNo}`,
//     data
//   );
// }
